import { CommonSelectInput } from 'components/common/form/select';
import { HittersContext } from 'contexts/hitters.context';
import { HitterRosterStatus } from 'lib_ts/enums/hitters.enums';
import { useContext } from 'react';

export const SelectHitterRosterStatus = () => {
  const { loading, filters, setFilters } = useContext(HittersContext);

  return (
    <CommonSelectInput
      id="hitters-roster-status"
      name="status"
      placeholder="common.status"
      options={Object.values(HitterRosterStatus).map((o) => ({
        label: o,
        value: o,
      }))}
      value={filters.status}
      onChange={(v) => {
        const current = filters;

        if (!v) {
          delete current.status;
        } else {
          current.status = v as HitterRosterStatus;
        }

        setFilters({ ...current });
      }}
      disabled={loading}
      optional
      skipSort
    />
  );
};
